<mat-card appearance="outlined" class="list">
  <mat-progress-bar *ngIf="isLyftListLoading$ | async" mode="indeterminate"></mat-progress-bar>
  <app-lyft-list
    [rideList]="rideList$ | async"
    (rideSelected)="handleRideSelected($event)"
    (paginationChanged)="handlePaginationChanged($event)"
    (searchChanged)="handleSearchChanged($event)"
    (filterChanged)="handleFilterChanged($event)">
  </app-lyft-list>
</mat-card>

<mat-card appearance="outlined" class="detail">
  <app-lyft-detail
    [detail]="(rideDetails$ | async)?.ride">
  </app-lyft-detail>
</mat-card>

<mat-card appearance="outlined" class="telemetry">
  <app-lyft-telemetry
    [detail]="(rideDetails$ | async)?.ride">
  </app-lyft-telemetry>
</mat-card>




